import { Alert, Card } from '@cmsgov/ds-medicare-gov'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

type PlansErrorAlertProps = {
  className?: string
}
export const PlansErrorAlert = ({ className }: PlansErrorAlertProps) => {
  const { t } = useTranslation('accountHome', {
    keyPrefix: 'currentPlans.errorAlert'
  })

  return (
    <Card className={classNames('ds-u-padding--3', className)}>
      <Alert variation="warn" heading={t('heading')}>
        {t('text')}
      </Alert>
    </Card>
  )
}
